const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

function getToken() {
  return localStorage.getItem('token');
}

function headers() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getToken()}`
  };
}

// AUTH
export async function loginAPI(correo, password) {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ correo, password })
  });
  return res.json();
}

// USUARIOS
export async function getUsuarios() {
  const res = await fetch(`${BASE_URL}/usuarios`, { headers: headers() });
  return res.json();
}

export async function crearUsuario(datos) {
  const res = await fetch(`${BASE_URL}/usuarios`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(datos)
  });
  return res.json();
}

export async function eliminarUsuario(id) {
  const res = await fetch(`${BASE_URL}/usuarios/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
}

// TALLERES
export async function getTalleres() {
  const res = await fetch(`${BASE_URL}/talleres`, { headers: headers() });
  return res.json();
}

export async function crearTaller(datos) {
  const res = await fetch(`${BASE_URL}/talleres`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(datos)
  });
  return res.json();
}

export async function eliminarTaller(id) {
  const res = await fetch(`${BASE_URL}/talleres/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
}

export async function crearModulo(tallerId, datos) {
  const res = await fetch(`${BASE_URL}/talleres/${tallerId}/modulos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(datos)
  });
  return res.json();
}

export async function eliminarModulo(moduloId) {
  const res = await fetch(`${BASE_URL}/talleres/modulos/${moduloId}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
}

// GRUPOS
export async function getGrupos() {
  const res = await fetch(`${BASE_URL}/grupos`, { headers: headers() });
  return res.json();
}

export async function crearGrupo(datos) {
  const res = await fetch(`${BASE_URL}/grupos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(datos)
  });
  return res.json();
}

export async function eliminarGrupo(id) {
  const res = await fetch(`${BASE_URL}/grupos/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
}

export async function inscribirEstudiante(grupoId, usuarioId) {
  const res = await fetch(`${BASE_URL}/grupos/${grupoId}/inscribir`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ usuario_id: usuarioId })
  });
  return res.json();
}

export async function desinscribirEstudiante(grupoId, usuarioId) {
  const res = await fetch(`${BASE_URL}/grupos/${grupoId}/desinscribir`, {
    method: 'DELETE',
    headers: headers(),
    body: JSON.stringify({ usuario_id: usuarioId })
  });
  return res.json();
}

export async function getGruposAlumno(usuarioId) {
  const res = await fetch(`${BASE_URL}/grupos/alumno/${usuarioId}`, { headers: headers() });
  return res.json();
}

// ENCUESTAS
export async function enviarEncuesta(datos) {
  const res = await fetch(`${BASE_URL}/encuestas`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(datos)
  });
  return res.json();
}

export async function getEncuestasGrupo(grupoId) {
  const res = await fetch(`${BASE_URL}/encuestas/grupo/${grupoId}`, { headers: headers() });
  return res.json();
}